import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={45.884}
      height={53.064}
      viewBox="0 0 45.884 53.064"
      {...props}
    >
      <g data-name="004---Phone">
        <path
          d="M43.949 37.922l-1.876 1.875-11.266-11.265 1.876-1.876a2.655 2.655 0 013.752 0l7.514 7.514a2.655 2.655 0 010 3.752z"
          fill="#ffb921"
        />
        <path
          data-name="Shape"
          d="M43.949 34.169l-7.513-7.513a2.648 2.648 0 00-3.2-.41 2.638 2.638 0 01.549.41l7.514 7.514a2.655 2.655 0 010 3.752l-.549.549 1.323 1.325 1.876-1.876a2.655 2.655 0 000-3.751z"
          fill="#fb8145"
        />
        <path
          data-name="Shape"
          d="M42.073 39.799l-3.133 3.133c-5 5-15.018-1.257-25.028-11.266S-2.363 11.638 2.646 6.638l3.133-3.133 11.257 11.266-2.044 2.044a1.77 1.77 0 00-.168 2.319 64.788 64.788 0 005.345 6.271 66.076 66.076 0 006.275 5.345 1.757 1.757 0 002.31-.168l2.053-2.053z"
          fill="#18206b"
        />
        <path
          data-name="Shape"
          d="M14.382 14.771l-2.045 2.044a1.77 1.77 0 00-.168 2.319 64.788 64.788 0 005.346 6.271 66.076 66.076 0 006.275 5.345 1.757 1.757 0 002.31-.168l.054-.054a64.886 64.886 0 01-5.984-5.123 64.787 64.787 0 01-5.348-6.271 1.77 1.77 0 01.168-2.319l2.044-2.044L5.779 3.505 4.452 4.832zM30.806 28.532l-1.327 1.327 9.938 9.939-3.133 3.133a5.818 5.818 0 01-3.16 1.644 6.416 6.416 0 005.815-1.644l3.13-3.133z"
          fill="#003586"
        />
        <path
          data-name="Shape"
          d="M18.921 12.894l-1.885 1.876L5.779 3.504l1.876-1.876a2.655 2.655 0 013.752 0l7.514 7.5a2.666 2.666 0 010 3.766z"
          fill="#ffd200"
        />
        <path
          data-name="Shape"
          d="M18.921 9.134l-7.514-7.5a2.649 2.649 0 00-3.2-.41 2.638 2.638 0 01.549.41l7.514 7.5a2.666 2.666 0 010 3.761l-.554.551 1.327 1.327 1.885-1.876a2.666 2.666 0 00-.007-3.763z"
          fill="#ffb921"
        />
        <g data-name="Group 564">
          <path
            data-name="Shape"
            d="M15.045 45.984H3.54a3.54 3.54 0 000 7.08h37.922a4.425 4.425 0 003.02-7.656l-3.5-3.268 3.591-3.59a3.54 3.54 0 000-5.006l-7.509-7.509a3.628 3.628 0 00-5.006 0l-1.876 1.876-2.048 2.049a.875.875 0 01-1.156.083 64.493 64.493 0 01-6.178-5.261 64.366 64.366 0 01-5.263-6.183.874.874 0 01.084-1.15l2.05-2.049 1.877-1.877a3.54 3.54 0 000-5.006l-7.512-7.515a3.628 3.628 0 00-5.006 0L5.151 2.878l-3.13 3.13c-4.842 4.842-.841 14.176 11.265 26.283 8.75 8.753 16.056 13.269 21.261 13.269a6.827 6.827 0 005.021-2l.163-.163 3.545 3.312a2.655 2.655 0 01-1.814 4.59H3.54a1.77 1.77 0 010-3.54h11.5a3.54 3.54 0 000-7.08H6.195a1.77 1.77 0 01-1.77-1.77v-4.43a.885.885 0 10-1.77 0v4.425a3.54 3.54 0 003.54 3.54h8.85a1.77 1.77 0 010 3.54zm18.265-18.7a1.812 1.812 0 012.5 0l7.509 7.509a1.77 1.77 0 010 2.5l-1.247 1.257-10.013-10.014zM8.279 2.253a1.77 1.77 0 012.5 0l7.512 7.507a1.77 1.77 0 010 2.5l-1.251 1.257L7.028 3.505zm6.258 28.787C3.4 19.904-.7 11.236 3.274 7.26l2.5-2.5 10.014 10.009-1.424 1.424a2.661 2.661 0 00-.243 3.474 66 66 0 005.422 6.366 66.433 66.433 0 006.365 5.427 2.665 2.665 0 003.475-.243l1.424-1.425L40.82 39.8l-1.757 1.76-.746.746c-3.979 3.975-12.643-.127-23.78-11.266zM30.975 15.009a.885.885 0 00.626-.259l6.195-6.195a.885.885 0 00-1.251-1.251l-6.195 6.195a.885.885 0 00.626 1.511zM27.435 12.355a.885.885 0 00.885-.885V3.505a.885.885 0 10-1.77 0v7.965a.885.885 0 00.885.885zM32.745 17.664a.885.885 0 00.885.885h7.965a.885.885 0 000-1.77H33.63a.885.885 0 00-.885.885z"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
